import AppSaga from './saga';
import * as AppSelectors from './selectors';
import * as AppReducer from './slice';
import { appSlice } from './slice';

export const AppActions = appSlice.actions;
export { AppReducer, AppSaga, AppSelectors };
